import React, { useState } from "react";
import moment from "moment";
import { Button, Modal } from "react-bootstrap";
import SoftBadge from "modules/common/SoftBadge";
import CardDiv from "modules/common/card-div/CardDiv";
import { Card, Image } from "antd";
import { FilePdfOutlined } from "@ant-design/icons";
import { formatDateAndTime } from "modules/utilities/utility";

function TicketModals({ showModal, setShowModal, selectedColumnData }) {
  const [showImageModal, setShowImageModal] = useState(false);
  const [zoom, setZoom] = useState(1);
  const [imageUrl, setImageUrl] = useState(null);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const closeModal = () => setShowImageModal(false);

  const handleImage = (image) => {
    setImageUrl(image);
    setShowImageModal(true);
  };

  return (
    <div>
      <Modal
        size="lg"
        style={{ zIndex: 9900, backgroundColor: "transparent !important" }}
        show={showModal}
        onHide={() => setShowModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <p className="mb-0 d-flex align-items-center gap-2">
              Ticket Number:{" "}
              <SoftBadge bg="info">{selectedColumnData?.ticketNumber}</SoftBadge>
            </p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedColumnData && (
            <>
              <div className=" d-flex gap-2  m-1">
                <div className="col-3 fw-bold ">Ticket Number:</div>
                <div className="col-6">{selectedColumnData?.ticketNumber}</div>
              </div>
              <div className=" d-flex gap-2  m-1">
                <div className="col-3 fw-bold ">Ticket ID:</div>
                <div className="col-6">{selectedColumnData?._id}</div>
              </div>
              <div className=" d-flex gap-2  m-1">
                <div className="col-3 fw-bold ">Created: </div>
                <div className="col-6">
                  {moment(
                    selectedColumnData?.createdAt,
                    "YYYY/MM/DD HH:mm:ss"
                  ).format("DD/MM/YYYY HH:mm:ss")}
                </div>
              </div>
              <div className=" d-flex gap-2  m-1">
                <div className="col-3 fw-bold ">Category:</div>
                <div className="col-6"> {selectedColumnData?.category}</div>
              </div>
              <div className=" d-flex gap-2  m-1">
                <div className="col-3 fw-bold "> Sub Category:</div>
                <div className="col-6">{selectedColumnData?.sub_category}</div>
              </div>
              <div className=" d-flex gap-2  m-1">
                <div className="col-3 fw-bold ">FAQ:</div>
                <div>{selectedColumnData?.faq_display_name}</div>
              </div>
              <div className=" d-flex gap-2  m-1">
                <div className="col-3 fw-bold ">Reasons:</div>
                <div>{selectedColumnData?.remark}</div>
              </div>
              <div className=" d-flex gap-2  m-1">
                <div className="col-3 fw-bold ">Request Type:</div>
                <div>{selectedColumnData?.request_type}</div>
              </div>
              <div className=" d-flex gap-2  m-1">
                <div className="col-3 fw-bold ">Priority:</div>
                <div>{selectedColumnData?.priority}</div>
              </div>
              <div className=" d-flex gap-2  m-1">
                <div className="col-3 fw-bold ">status:</div>
                <div>{selectedColumnData?.status}</div>
              </div>
              <div className=" d-flex gap-2  m-1">
                <div className="col-3 fw-bold ">Order Detail:</div>
                <div>{selectedColumnData?.source_meta?.order_details}</div>
              </div>
              <div className=" d-flex gap-2  m-1">
                <div className="col-3 fw-bold ">Assigned To:</div>
                <div>{selectedColumnData?.current_assignment?.first_name}</div>
              </div>
              <div className=" d-flex gap-2  m-1">
                <div className="col-3 fw-bold ">Author:</div>
                <div>{selectedColumnData?.author?.first_name}</div>
              </div>
              <div className=" d-flex gap-2  m-1">
                <div className="col-3 fw-bold ">Customer:</div>
                <div>
                  {selectedColumnData?.customer?.first_name}{" "}
                  {selectedColumnData?.customer.email}
                </div>
              </div>
              <div className=" d-flex gap-2  m-1">
                <div className="col-3 fw-bold ">Comments:</div>
                <div>
                  {selectedColumnData?.comments?.map((comment, index) => (
                    <div className="comment" key={index}>
                      <div className="comment-details">
                        <div className="comment-name">
                          {comment?.action_taker?.first_name} {"---> "}
                          <span className="comment-date">
                            {formatDateAndTime(comment?.created_at)} {"---> "}
                          </span>
                          <span className="comment-description">
                            {comment?.description}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <CardDiv
                title={"Photos"}
                component={
                  <div>
                    <div
                      className="d-flex flex-wrap scrollable-container gap-3"
                      style={{ height: "12rem", overflowY: "scroll" }}
                    >
                      {selectedColumnData?.images?.map((image, index) => {
                        if (!image.includes(".pdf")) {
                          return (
                            <div>
                              <img
                                src={image}
                                alt="Image"
                                style={{
                                  cursor: "pointer",
                                  width: "112px",
                                  height: "112px",
                                }}
                                onClick={() => handleImage(image)}
                              />
                            </div>
                          );
                        } else return null;
                      })}
                      {selectedColumnData?.images?.map((image, index) => {
                        let name = image.split("?")[0] || null;
                        name = name ? name.split("/") : null;
                        name = name ? name[name.length - 1] : null;
                        name = "PDF: " + name.substring(0, 10) + "...";
                        if (image.includes(".pdf")) {
                          return (
                            <p>
                              <Card
                                style={{
                                  width: "105px",
                                  height: "110px",
                                }}
                                bordered
                                hoverable
                              >
                                <a href={image} target="_blank">
                                  <FilePdfOutlined
                                    style={{ fontSize: "400%" }}
                                  />
                                </a>
                              </Card>
                            </p>
                          );
                        } else return null;
                      })}
                    </div>
                  </div>
                }
              />
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            class="btn btn-primary"
            onClick={() => setShowModal(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
      <Modal
        style={{
          zIndex: "99999999",
          backgroundColor: "transparent !important",
        }}
        size="md"
        show={showImageModal}
        onHide={closeModal}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Zoomed Image</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              overflow: "hidden",
              width: "100%",
              height: "600px", // Adjust the height to your desired size
              position: "relative",
            }}
          >
            <img
              src={imageUrl}
              alt="Image"
              style={{
                width: "100%",
                height: "auto",
                transform: `scale(${zoom}) translate(${position.x}px, ${position.y}px)`,
                cursor: "grab",
              }}
              onMouseDown={(e) => {
                e.target.style.cursor = "grabbing";
                const startX = e.clientX - position.x;
                const startY = e.clientY - position.y;

                const onMouseMove = (e) => {
                  setPosition({
                    x: e.clientX - startX,
                    y: e.clientY - startY,
                  });
                };

                const onMouseUp = () => {
                  e.target.style.cursor = "grab";
                  document.removeEventListener("mousemove", onMouseMove);
                  document.removeEventListener("mouseup", onMouseUp);
                };

                document.addEventListener("mousemove", onMouseMove);
                document.addEventListener("mouseup", onMouseUp);
              }}
            />
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={closeModal}>
            Close
          </Button>
          <Button variant="primary" onClick={() => setZoom(zoom + 0.1)}>
            Zoom In
          </Button>
          <Button variant="primary" onClick={() => setZoom(zoom - 0.1)}>
            Zoom Out
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default TicketModals;
